// src/ChangePasswordModal.js
import React, { useState } from 'react';
import { auth } from './firebaseConfig';
import { updatePassword, EmailAuthProvider, reauthenticateWithCredential } from 'firebase/auth';

function ChangePasswordModal({ onClose }) {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');

  const handleChangePassword = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');

    if (newPassword !== confirmPassword) {
      setError("As novas senhas não coincidem.");
      return;
    }
    if (newPassword.length < 6) {
      setError("A nova senha deve ter pelo menos 6 caracteres.");
      return;
    }

    const user = auth.currentUser;
    if (!user || !user.email) {
      setError("Nenhum usuário logado. Por favor, faça login novamente.");
      return;
    }

    try {
      // 1. Reautenticar o usuário por segurança
      const credential = EmailAuthProvider.credential(user.email, currentPassword);
      await reauthenticateWithCredential(user, credential);

      // 2. Atualizar a senha
      await updatePassword(user, newPassword);
      setMessage("Senha alterada com sucesso!");
      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
      setTimeout(onClose, 2000); // Fecha o modal após 2 segundos
    } catch (err) {
      console.error("Erro ao mudar senha:", err.message);
      if (err.code === 'auth/wrong-password') {
        setError("Senha atual incorreta.");
      } else if (err.code === 'auth/requires-recent-login') {
        setError("Por favor, faça login novamente e tente mudar a senha em seguida.");
      } else {
        setError("Erro ao alterar senha. Por favor, tente novamente.");
      }
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <form onSubmit={handleChangePassword} className="bg-white p-6 rounded-lg w-full max-w-md shadow-2xl space-y-4">
        <h2 className="text-xl font-bold">Alterar Senha</h2>
        <div>
          <label className="block text-sm font-medium text-gray-700">Senha Atual</label>
          <input type="password" className="w-full p-2 border rounded mt-1" value={currentPassword} onChange={e => setCurrentPassword(e.target.value)} required />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700">Nova Senha</label>
          <input type="password" className="w-full p-2 border rounded mt-1" value={newPassword} onChange={e => setNewPassword(e.target.value)} required />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700">Confirmar Nova Senha</label>
          <input type="password" className="w-full p-2 border rounded mt-1" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} required />
        </div>
        {error && <p className="text-red-500 text-sm">{error}</p>}
        {message && <p className="text-green-500 text-sm">{message}</p>}
        <div className="flex justify-end gap-2 pt-4 border-t">
          <button type="button" onClick={onClose} className="px-4 py-2 text-gray-600">Cancelar</button>
          <button type="submit" className="bg-blue-600 text-white px-4 py-2 rounded">Alterar Senha</button>
        </div>
      </form>
    </div>
  );
}
export default ChangePasswordModal;